import React from "react";
import UsrProfImg from "../../assets/user.png";
import { CheckRole } from "../../Services/AuthService";

const UserInfo = ({ fullName, variant, onAvatarClick }) => {
  const wrapperClass =
    variant === "mobile" ? "profile-section" : "dropdown-user-info";
  const avatarClass =
    variant === "mobile" ? "profile-avatar" : "dropdown-user-avatar";
  const roleClass =
    variant === "mobile" ? "profile-role" : "dropdown-user-role";

  return (
    <div className={wrapperClass}>
      <img
        src={UsrProfImg}
        alt="Profile"
        className={avatarClass}
        onClick={onAvatarClick}
        style={{ cursor: "pointer" }}
      />
      <div>
        <div className="profile-name mt-3">{fullName || "کاربر"}</div>
        <div className={roleClass}>
          {CheckRole(["Admin"])
            ? "مدیر"
            : CheckRole(["Doctor"])
            ? "پزشک"
            : CheckRole(["Secretary"])
            ? "منشی"
            : "کاربر"}
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
